
type Peak = {
    mz: number;
    int: number;
}

export const getShiftedSpectra = (shift: number = 0, masses: Peak[]): Peak[] => {
    if(!masses) return []
    if(masses.length === 0) return []
    if(shift === 0) return masses

    const shiftFactor = shift / 1000000

    return masses.map(x => ({
        mz: x.mz + shiftFactor * x.mz,
        int: x.int
    }))
}